import React from 'react'

import { Link } from 'react-router-dom';

function University() {

    

    return (
        <>

            <marquee behavior="scroll" scrollamount="14" bgcolor="#fdc800" height="40pxl">
                <h3> University Course Registration Apply Easy 3 Step</h3>
            </marquee>

            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/university1.jpg" alt="slider" title="#slider-direction-1" />
                        <img src="/images/university2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="courses-page-area2 pt-5 pb-5">
                <div className="container " id="inner-isotope">
                    <div className="row ">
                        <h3 className='title-center title-bar-counter'>University Courses</h3>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">

                            <div className='container d-flex justify-content-center pt-3 pb-3'>
                                <div className='row'>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5  p-3 " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course1.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">BA | MA</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course2.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">B.Com | M.Com</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3 " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course3.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">BBA | MBA</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course-4.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">B.Sc. | M.Sc.</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course-5.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">B.Tech | M.Tech | Diploma</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course6.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">DMLT | BMLT | OTT</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course7.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">DMLT | BMLT | OTT</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course8.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">D.Pharma | B.Pharma</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-sm-6 col-xs-12 col-md-4 d-flex justify-content-center'>
                                        <div className="card-uni  mb-5 p-3  " style={{ width: '18rem' }}>
                                            <img src="/images/uni-course9.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h5 className="card-title">Ph.D.</h5>
                                                <Link to='/contact'>
                                                    <button className='btn view-all-accent-btn'>Contact Us</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

export default University